import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
import withPasswordProtection from "../../util/WithPasswordProtection";

var classNames = require("classnames");
import API from "../../api/index";
import { Row, Card, Button, Input, Form, FormGroup, CardTitle, Label, Collapse, CardBody, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";
import moment from "jalali-moment";
import { Colxx } from "Components/CustomBootstrap";
import "react-circular-progressbar/dist/styles.css";
import "react-tabs/style/react-tabs.css";
import StateButton from "Components/StateButton";
import Tooltip from "react-simple-tooltip";
import NumberFormat from "react-number-format";
import Select from "react-select";
import CustomSelectInput from "Components/CustomSelectInput";

import { RangeDatePicker } from "jalali-react-datepicker";
import DateOnlyPicker from '../../components/DateOnlyPicker';
import { pickerDay } from '../../util/date-only';
import { validJournalInteger } from '../../util/journal-input';
import { todayTehran } from './purchase-model';
import { NotificationManager } from "Components/ReactNotifications";
import { PurchaseButton } from './purchase-ui';

class AccountingJournal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showDetails: false,
			isRefreshing: false,
			modalCreateTransactionOpen: false,
			collapseFilterOpen: false,
			tab: "ALL",

			inflowSources: [],
			search: {
				transactionAmount: "",
				transactionAmountOperator: "=",
				transactionDescription: "",
				transactionType: "ALL",
				transactionCreatedAt: "",
				transactionDate: "",

				transactionInflowSource: "ALL",
				sortColumn: "transactionDate",
				sortDirection: "ZA",
				currentPage: 1,
				descriptionInputType: "text",
			},
			APISearchData: {},
			searchReset: null,

			newTransaction: {
				amount: "",
				type: "OUTFLOW",
				date: `${todayTehran()}T23:59:59`,
				inflowSource: null,
				description: "",
			},
			newTransactionReset: null,
			newTransactionButtonClicked: false,
			transactions: [],
			paging: [],
			summary: false,
			isLoading: true,
			bankCards: [],
			BankCardID: -1,
			showSearchSummary: false,
			SearchSummaryData: null,
		};
		this.modalCreateTransactionToggle = this.modalCreateTransactionToggle.bind(this);
		this.collapseFilterToggle = this.collapseFilterToggle.bind(this);
		this.validateSearchFilter = this.validateSearchFilter.bind(this);
		this.validatenewTransactionFilter = this.validatenewTransactionFilter.bind(this);
		this.setTransactionCreatedDateRange = this.setTransactionCreatedDateRange.bind(this);
		this.setTransactionDate = this.setTransactionDate.bind(this);
		this.setNewTransactionDate = this.setNewTransactionDate.bind(this);
		this.remainingDays = this.remainingDays.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.handleTransactionCreateReset = this.handleTransactionCreateReset.bind(this);
		this.handleSearchReset = this.handleSearchReset.bind(this);
		this.validateTransactionCreation = this.validateTransactionCreation.bind(this);
		this.handleCreateTransactionButtonClick = this.handleCreateTransactionButtonClick.bind(this);
		this.handleSortClick = this.handleSortClick.bind(this);
		this.loadData = this.loadData.bind(this);
		this.doSearch = this.doSearch.bind(this);
		this.handleBankCardSelection = this.handleBankCardSelection.bind(this);
		this.generateBankCardSelectData = this.generateBankCardSelectData.bind(this);
	}
	generateBankCardSelectData() {
		const selectData = this.state.bankCards.map((bankCard, index) => ({
			label: `${bankCard.bankName} - ${bankCard.name} ${bankCard.surname} - ${bankCard.cardNumber.slice(-4)}`,
			value: bankCard.id,
			key: index,
		}));
		return selectData;
	}

	handleBankCardSelection(selectedOption) {
		this.setState({
			selectedOption,
			BankCardID: selectedOption.value,
		});
	}
	handleFocus = (event) => event.target.select();
	handleSortClick(column) {
		this.setState(
			(prevState) => {
				const newSearch = { ...prevState.search };
				if (newSearch.sortColumn !== column) {
					newSearch.sortColumn = column;
					newSearch.sortDirection = "AZ";
				} else {
					newSearch.sortDirection = newSearch.sortDirection === "AZ" ? "ZA" : "AZ";
				}
				return { search: newSearch };
			},
			() => {
				this.doSearch();
			}
		);
	}

	handleTransactionCreateReset() {
		// reset newTransaction to the initial state
		const newTransactionResetTemp = this.state.newTransactionReset;
		this.setState({ newTransaction: { ...newTransactionResetTemp } });
	}

	handleSearchReset() {
		// reset newTransaction to the initial state
		const newSearchResetTemp = this.state.searchReset;
		this.setState({ search: { ...newSearchResetTemp }, showSearchSummary: false, SearchSummaryData: null, APISearchData: { ...this.state.searchReset } }, () => {
			this.loadData();
		});
	}

	setTransactionCreatedDateRange(range, param) {
		var tmpObj = this.state.search;
		tmpObj.transactionCreatedAt = range;
		this.setState({ search: tmpObj });
	}
	setTransactionDate(range, param) {
		var tmpObj = this.state.search;
		tmpObj.transactionDate = range;
		this.setState({ search: tmpObj });
	}
	setNewTransactionDate(date) {
		const day = pickerDay(date.value);
		if (day) {
			var dataTime = `${day}T23:59:59`;
			var tmpObj = this.state.newTransaction;
			tmpObj.date = dataTime;
			this.setState({ newTransaction: tmpObj });
		}
	}
	remainingDays(date) {
		const targetDate = new Date(date);
		const today = new Date();
		const timeDiff = targetDate.getTime() - today.getTime();
		const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

		return daysDiff;
	}
	validatenewTransactionFilter(filter, value) {
		if (value === undefined) {
			return false;
		}
		switch (filter) {
			case "transaction-amount":
				if (validJournalInteger(value)) {
					return true;
				}
				break;
			case "transaction-description":
				if (value.length > 2) {
					return true;
				}
				break;
			case "transaction-date":
				if (value != "" && this.remainingDays(value) <= 1) {
					return true;
				}
				break;
			case "transaction-inflowsource":
				if (this.state.newTransaction.type == "INFLOW") {
					if (this.state.newTransaction.inflowSource != null) {
						return true;
					}
				} else {
					return true;
				}
				break;
		}
		return false;
	}
	validateTransactionCreation() {
		const filters = {
			"transaction-amount": this.state.newTransaction.amount,
			"transaction-date": this.state.newTransaction.date,
			"transaction-description": this.state.newTransaction.description,
			"transaction-inflowsource": this.state.newTransaction.inflowSource,
		};

		for (const [key, value] of Object.entries(filters)) {
			if (!this.validatenewTransactionFilter(key, value)) {
				return false;
			}
		}

		return true;
	}
	validateSearchFilter(filter, value) {
		switch (filter) {
			case "coupon-code":
				var pattern = /^[a-zA-Z0-9-]+$/;
				var match = pattern.test(value);
				if ((value.length > 0) & match) {
					return true;
				}
				break;
			case "coupon-subject":
				if (value.length > 0) {
					return true;
				}
				break;
			case "coupon-description":
				if (value.length > 0) {
					return true;
				}
				break;
		}
		return false;
	}
	collapseFilterToggle() {
		this.setState({
			collapseFilterOpen: !this.state.collapseFilterOpen,
		});
	}
	modalCreateTransactionToggle() {
		this.setState({
			modalCreateTransactionOpen: !this.state.modalCreateTransactionOpen,
		});
	}
	componentDidMount() {
		window.addEventListener('akschap-purchase-saved', this.loadData);
		const newTransactionReset = { ...this.state.newTransaction };
		const searchReset = { ...this.state.search };
		const apiSerachData = { ...this.state.search };
		this.setState(
			{
				newTransactionReset: { ...newTransactionReset },
				searchReset: { ...searchReset },
				APISearchData: { ...apiSerachData },
			},
			() => {
				this.loadData();
			}
		);
	}

	componentWillUnmount() {
		window.removeEventListener('akschap-purchase-saved', this.loadData);
	}
	handleCreateTransactionButtonClick() {
		return new Promise((success, fail, $this) => {
			this.setState({ newTransactionButtonClicked: true });
			API.post("accounting/transaction/add", this.state.newTransaction)
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ثبت تراکنش");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت تراکنش", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								newTransactionButtonClicked: false,
							});
						}
					} else {
						success("تراکنش ثبت شد");
						setTimeout(() => {
							this.setState({ newTransactionButtonClicked: false, modalCreateTransactionOpen: false });
							this.handleTransactionCreateReset();
							this.loadData();
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در ثبت تراکنش");
				});
		});
	}
	doSearch() {
		const tmpObj = JSON.parse(JSON.stringify(this.state.search));
		tmpObj.currentPage = 1;

		let SearchSummaryData = { ...tmpObj }; // Create a separate object for cachedSearchData

		const selectedCard = this.state.bankCards.find((card) => card.id === this.state.BankCardID) || null;

		if (this.state.search.descriptionInputType === "card" && selectedCard) {
			tmpObj.transactionDescription = selectedCard.cardNumber;
			SearchSummaryData.transactionDescription = `${selectedCard.name} ${selectedCard.surname} - ${selectedCard.cardNumber} - ${selectedCard.bankName}`;

			this.setState({ showDetails: true });
		}

		this.setState(
			{
				APISearchData: tmpObj,
				showSearchSummary: true,
				SearchSummaryData,
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}

	loadData() {
		this.setState({ isRefreshing: true });
		API.post("accounting/transactions/list", this.state.APISearchData)
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

				const inflowSources = data.settings.transactions.inflowSources.map((item, index) => ({
					label: item,
					value: item,
					key: 10001 + index,
				}));

				this.setState(
					{
						transactions: data.transactions,
						bankCards: data.bankCards,
						paging: data.paging,
						summary: data.summary,
						settings: data.settings,
						isLoading: false,
						isRefreshing: false,
						inflowSources: inflowSources,
					},
					function () {}
				);
			})
			.catch((error) => {});
	}
	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className={"invoice"}>
					<Colxx xl="12">
						<Card>
							<CardBody>
								<CardTitle className={"print-hide"}>
									<div
										className={"iconsminds-calendar-4 headingicon"}
										onClick={() => {
											this.setState({ showDetails: !this.state.showDetails });
										}}
										style={{ color: this.state.showDetails ? "#4fcdc4" : "#556270" }}
									/>
									دفتر روزنامه
									<PurchaseButton />
									<Button
										color="primary"
										outline
										style={{ float: "left" }}
										className={"default"}
										onClick={() => {
											this.setState({ modalCreateTransactionOpen: true });
										}}
									>
										<i className="iconsminds-add icon-size-20" style={{ fontWeigh: "bold" }}></i>&nbsp; تراکنش جدید
									</Button>
									<Modal size="lg" isOpen={this.state.modalCreateTransactionOpen} toggle={this.modalCreateTransactionToggle}>
										<ModalHeader toggle={this.modalCreateTransactionToggle}>ثبت تراکنش</ModalHeader>
										<ModalBody>
											<Row>
												<Colxx sm={4}>
													<FormGroup className={"filter " + (this.validatenewTransactionFilter("transaction-amount", this.state.newTransaction.amount) ? "filter-active" : "")}>
														<Label for="newTransactionAmount" style={{ width: "100%" }}>
															مبلغ (تومان) *
														</Label>
														<NumberFormat
															value={this.state.newTransaction.amount}
															onClick={this.handleFocus}
															onValueChange={(values) => {
																var tmpObj = { ...this.state.newTransaction };
																tmpObj.amount = values.value;
																this.setState({ newTransaction: tmpObj });
															}}
															style={{ width: "60%", height: "40px", border: "1px solid #d7d7d7", display: "inline-block", float: "right" }}
															thousandSeparator={true}
														/>
														<span
															style={{
																border: "1px solid ",
																borderColor: this.state.newTransaction.type == "OUTFLOW" ? "#ffd3d3" : "#d3ffd5",
																borderRadius: "5px",
																background: this.state.newTransaction.type == "OUTFLOW" ? "#ffd3d3" : "#d3ffd5",
																cursor: "pointer",
																marginRight: 10,
																display: "inline-block",
																width: "30%",
																height: "40px",
																lineHeight: "30px",
																textAlign: "center",
																paddingTop: "5px",
																paddingLeft: "10px",
																paddingRight: "10px",
																textAlign: "center",
																flaot: "left",
																color: this.state.newTransaction.type == "OUTFLOW" ? "red" : "green",
															}}
															onClick={(e) => {
																var tmpObj = { ...this.state.newTransaction };
																tmpObj.type = this.state.newTransaction.type == "OUTFLOW" ? "INFLOW" : "OUTFLOW";
																this.setState({ newTransaction: tmpObj });
															}}
														>
															{this.state.newTransaction.type == "OUTFLOW" ? "برداشت" : "واریز"}
														</span>
													</FormGroup>
												</Colxx>
												<Colxx sm={4} style={{ opacity: this.state.newTransaction.type == "INFLOW" ? 1 : "0.3" }}>
													<FormGroup className={"filter " + (this.validatenewTransactionFilter("transaction-inflowsource", this.state.newTransaction.inflowSource) ? "filter-active" : "")}>
														<Label for="newTransactionAmount" style={{ width: "100%" }}>
															منبع *
														</Label>
														<Select
															components={{ Input: CustomSelectInput }}
															classNamePrefix="react-select"
															name="form-field-name"
															value={this.state.newTransaction.inflowSource}
															onChange={(selectedOption) => {
																var tmpObj = { ...this.state.newTransaction };
																tmpObj.inflowSource = selectedOption;
																this.setState({ newTransaction: tmpObj });
															}}
															isDisabled={this.state.newTransaction.type != "INFLOW"}
															placeholder="انتخاب کنید ..."
															options={this.state.inflowSources}
														/>
													</FormGroup>
												</Colxx>
												<Colxx sm={4}>
													<FormGroup className={"filter " + (this.validatenewTransactionFilter("transaction-date", this.state.newTransaction.date) ? "filter-active" : "")}>
														<Label for="newTransactionCode">تاریخ *</Label>

														<DateOnlyPicker value={this.state.newTransaction.date.slice(0, 10)} label="تاریخ تراکنش" onChange={date => this.setState({ newTransaction: { ...this.state.newTransaction, date: `${date}T23:59:59` } })} />
													</FormGroup>
												</Colxx>
											</Row>

											<Row>
												<Colxx sm={12}>
													<FormGroup className={"filter " + (this.validatenewTransactionFilter("transaction-description", this.state.newTransaction.description) ? "filter-active" : "")}>
														<Label for="newTransactionDescription">توضیحات *</Label>

														<Input
															type="text"
															name="newTransactionDescription"
															id="newTransactionDescription"
															onClick={this.handleFocus}
															placeholder="خرید لیوان خام از چین ..."
															value={this.state.newTransaction.description}
															onChange={(e) => {
																var tmpObj = { ...this.state.newTransaction };
																tmpObj.description = e.target.value;
																this.setState({ newTransaction: tmpObj });
															}}
														/>
													</FormGroup>
												</Colxx>
											</Row>
										</ModalBody>
										<ModalFooter>
											<Button
												color="light"
												style={{
													float: "left",
													marginLeft: "10px",
													marginTop: "-14px",
												}}
												className={"default"}
												onClick={this.handleTransactionCreateReset}
											>
												ریست
											</Button>
											<StateButton disabled={!this.validateTransactionCreation()} id="newBatchSaveButton" color="primary" className="mb-3 default" onClick={() => this.handleCreateTransactionButtonClick()}>
												ثبت
											</StateButton>
										</ModalFooter>
									</Modal>
								</CardTitle>
								<Fragment>
									<div className="border productPanel print-hide">
										<Button block color="link" className="text-right" onClick={() => this.collapseFilterToggle()} aria-expanded={this.state.collapseFilterOpen}>
											<i className="glyph-icon simple-icon-magnifier" style={{ marginLeft: "5px", fontSize: "14px" }}></i>
											فرم جستجو
											<i className="glyph-icon simple-icon-arrow-down" style={{ marginRight: "10px", fontSize: "10px" }}></i>
										</Button>

										<div
											className="dropdown-buttons"
											style={{
												float: "left",
												display: this.state.collapseFilterOpen ? "inline-block" : "none",
											}}
										>
											<Button
												color="primary"
												className={"default"}
												style={{
													float: "left",
													marginLeft: "10px",
												}}
												onClick={this.doSearch}
											>
												جستجو کن
											</Button>
											<Button
												color="light"
												style={{
													float: "left",
													marginLeft: "10px",
												}}
												className={"default"}
												onClick={this.handleSearchReset}
											>
												ریست
											</Button>
										</div>
										<Collapse isOpen={this.state.collapseFilterOpen} style={{ marginTop: "0px" }}>
											<div className="" style={{ padding: "20px", paddingBottom: 0 }}>
												<Row className="mb-4">
													<Colxx xxs="12">
														<Form>
															<FormGroup row>
																<Colxx sm={3}>
																	<FormGroup className={"filter " + (this.validateSearchFilter("coupon-code", this.state.search.transactionAmount) ? "filter-active" : "")}>
																		<Label for="transactionAmount">مبلغ تراکنش</Label>
																		<span
																			style={{
																				border: "1px solid lightgray",
																				borderRadius: "5px",
																				background: "#eaeaea",
																				cursor: "pointer",
																				marginRight: 10,
																				display: "inline-block",
																				width: "25px",
																				textAlign: "center",
																				paddingTop: "5px",
																			}}
																			onClick={(e) => {
																				const operators = ["=", ">", "<", ">=", "=<"];
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionAmountOperator = operators[(operators.indexOf(this.state.search.transactionAmountOperator) + 1) % operators.length];
																				this.setState({ search: tmpObj });
																			}}
																		>
																			{this.state.search.transactionAmountOperator}
																		</span>{" "}
																		<span style={{ color: "lightgray" }}>{this.state.search.transactionAmountOperator == "=" ? "با" : "از"} مقدار وروردی</span>
																		<NumberFormat
																			type="text"
																			name="transactionAmount"
																			id="transactionAmount"
																			value={this.state.search.transactionAmount}
																			onClick={this.handleFocus}
																			onValueChange={(values) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionAmount = values.value;
																				this.setState({ search: tmpObj });
																			}}
																			style={{ width: "100%", height: "40px", border: "1px solid #d7d7d7" }}
																			thousandSeparator={true}
																		/>
																	</FormGroup>
																	<FormGroup className={"filter " + (this.state.search.transactionType != "ALL" ? "filter-active" : "")}>
																		<Label>نوع تراکنش</Label>
																		<Input
																			type="select"
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionType = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																			value={this.state.search.transactionType}
																		>
																			<option value="ALL">همه نوع</option>
																			<option value="INFLOW">واریز</option>
																			<option value="OUTFLOW">برداشت</option>
																		</Input>
																	</FormGroup>
																</Colxx>
																<Colxx sm={3}>
																	<FormGroup className={"filter " + (this.state.search.transactionInflowSource != "ALL" ? "filter-active" : "")}>
																		<Label>منبع واریز</Label>
																		<Input
																			type="select"
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionInflowSource = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																			value={this.state.search.transactionInflowSource}
																		>
																			<option value="ALL">همه</option>
																			{this.state.inflowSources.map((source) => (
																				<option key={"search-inflowsources-" + source.key} value={source.value}>
																					{source.value}
																				</option>
																			))}
																		</Input>
																	</FormGroup>

																	<FormGroup style={{ marginBottom: 0 }} className={"filter " + (this.validateSearchFilter("coupon-description", this.state.search.transactionDescription) ? "filter-active" : "")}>
																		<Label for="transactionDescription">توضیحات تراکنش (شامل)</Label>

																		<i
																			onClick={() => {
																				this.setState((prevState) => ({
																					search: {
																						...prevState.search,
																						descriptionInputType: prevState.search.descriptionInputType === "text" ? "card" : "text",
																					},
																				}));
																			}}
																			style={{
																				border: "1px solid lightgray",
																				borderRadius: "5px",
																				background: "rgb(234, 234, 234)",
																				cursor: "pointer",
																				marginRight: "10px",
																				display: "inline-block",
																				width: "31px",
																				textAlign: "center",
																				fontSize: "20px",
																				height: "25px",
																				maxHeight: "25px",
																				minHeight: "25px",
																			}}
																			className={"input-icon-switch " + (this.state.search.descriptionInputType === "text" ? "iconsminds-align-left" : "simple-icon-credit-card")}
																		></i>

																		{this.state.search.descriptionInputType === "text" ? (
																			<Input
																				type="text"
																				name="transactionDescription"
																				id="transactionDescription"
																				onClick={this.handleFocus}
																				placeholder=""
																				value={this.state.search.transactionDescription}
																				onChange={(e) => {
																					var tmpObj = { ...this.state.search };
																					tmpObj.transactionDescription = e.target.value;
																					this.setState({ search: tmpObj });
																				}}
																			/>
																		) : (
																			<Select
																				components={{ Input: CustomSelectInput }}
																				className="react-select"
																				classNamePrefix="react-select"
																				name="form-field-name"
																				value={this.state.selectedOption}
																				onChange={this.handleBankCardSelection}
																				options={this.generateBankCardSelectData()} // Call the function to generate options
																				placeholder="انتخاب کنید..."
																			/>
																		)}
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.transactionDate != "" ? "filter-active" : "")}>
																		<Button
																			style={{
																				float: "left",
																				padding: "5px",
																				color: "black",
																				backgroundColor: "transparent",
																				border: "unset",
																				display: this.state.search.transactionDate != "" ? "block" : "none",
																			}}
																			onClick={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionDate = "";
																				this.setState({ search: tmpObj });
																			}}
																		>
																			<i className="simple-icon-close"></i>
																		</Button>
																		<RangeDatePicker fromLabel="تراکنش ها از تاریخ" toLabel="تراکنش ها تا تاریخ" onClickSubmitButton={this.setTransactionDate} />
																	</FormGroup>
																</Colxx>
																{this.state.showDetails && (
																	<Colxx sm={2}>
																		<FormGroup className={"filter " + (this.state.search.transactionCreatedAt != "" ? "filter-active" : "")}>
																			<Button
																				style={{
																					float: "left",
																					padding: "5px",
																					color: "black",
																					backgroundColor: "transparent",
																					border: "unset",
																					display: this.state.search.transactionCreatedAt != "" ? "block" : "none",
																				}}
																				onClick={(e) => {
																					var tmpObj = { ...this.state.search };
																					tmpObj.transactionCreatedAt = "";
																					this.setState({ search: tmpObj });
																				}}
																			>
																				<i className="simple-icon-close"></i>
																			</Button>
																			<div className="datepicker">
																				<RangeDatePicker fromLabel="ثبت شده از تاریخ" toLabel="ثبت شده تا تاریخ" onClickSubmitButton={this.setTransactionCreatedDateRange} />
																			</div>
																		</FormGroup>
																	</Colxx>
																)}
															</FormGroup>
														</Form>
													</Colxx>
												</Row>
											</div>
										</Collapse>
									</div>
									<br />
								</Fragment>
								<Fragment>
									{this.state.showSearchSummary && (
										<table className="search-summary-table">
										<tbody>
											<tr>
												<th>مبلغ تراکنش</th>
												<td>
													{this.state.SearchSummaryData.transactionAmount ? (
														<NumberFormat
															value={this.state.SearchSummaryData.transactionAmount}
															displayType={"text"}
															thousandSeparator={true}
															suffix=" تومان "
															prefix={` ${this.state.SearchSummaryData.transactionAmountOperator || ""} `}
															renderText={(value) => <span>{value}</span>}
														/>
													) : (
														"-"
													)}
												</td>
												<th>نوع تراکنش</th>
												<td>
													{{
														"ALL": "همه نوع",
														"INFLOW": "واریز",
														"OUTFLOW": "برداشت"
													}[this.state.SearchSummaryData.transactionType] || "-"}
												</td>
											</tr>
											<tr>
												<th>منبع واریز</th>
												<td>
													{{
														"ALL": "همه",
														"BANK": "بانک",
														"CASH": "نقدی"
													}[this.state.SearchSummaryData.transactionInflowSource] || "-"}
												</td>
												<th>توضیحات تراکنش</th>
												<td>{this.state.SearchSummaryData.transactionDescription || "-"}</td>
											</tr>
											<tr>
												<th>تاریخ تراکنش از</th>
												<td>{this.state.SearchSummaryData.transactionDate?.start ? moment(this.state.SearchSummaryData.transactionDate.start).locale('fa').format('YYYY/MM/DD') : "-"}</td>
												<th>تاریخ تراکنش تا</th>
												<td>{this.state.SearchSummaryData.transactionDate?.end ? moment(this.state.SearchSummaryData.transactionDate.end).locale('fa').format('YYYY/MM/DD') : "-"}</td>
											</tr>
											<tr>
												<th>ثبت شده از تاریخ</th>
												<td>{this.state.SearchSummaryData.transactionCreatedAt?.start ? moment(this.state.SearchSummaryData.transactionCreatedAt.start).locale('fa').format('YYYY/MM/DD') : "-"}</td>
												<th>ثبت شده تا تاریخ</th>
												<td>{this.state.SearchSummaryData.transactionCreatedAt?.end ? moment(this.state.SearchSummaryData.transactionCreatedAt.end).locale('fa').format('YYYY/MM/DD') : "-"}</td>
											</tr>
										</tbody>
									</table>
									
									)}
								</Fragment>
								<div className="table-responsive print-show">
									<table className={"table table-hover order-table print-table" + (this.state.showDetails ? " show-details" : "")}>
										<thead>
											<tr>
												{this.state.showDetails && <th style={{ width: "100px" }}>اپراتور</th>}
												{this.state.showDetails && (
													<th style={{ width: "200px", cursor: "pointer" }} onClick={() => this.handleSortClick("created")}>
														تاریخ ثبت
														{this.state.search.sortColumn === "created" && (
															<i style={{ marginRight: "5px",fontWeight: "bold" }} className={`${this.state.search.sortDirection === "AZ" ? "iconsminds-triangle-arrow-up" : "iconsminds-triangle-arrow-down"}`} ></i>
														)}
													</th>
												)}
												<th style={{ width: "50px", display: "none" }} className={"print-show-cell"}>
													ردیف
												</th>
												<th style={{ width: "100px" }}>کد</th>
												<th style={{ width: "100px" }}>نوع</th>
												<th style={{ width: "100px" }}>منبع واریز</th>
												<th style={{ textAlign: "right" }}>توضیحات</th>

												<th style={{ width: "150px", cursor: "pointer" }} onClick={() => this.handleSortClick("transactionDate")}>
													تاریخ
													{this.state.search.sortColumn === "transactionDate" && (
														<i style={{ marginRight: "5px",fontWeight: "bold"  }} className={`${this.state.search.sortDirection === "AZ" ? "iconsminds-triangle-arrow-up" : "iconsminds-triangle-arrow-down"}`} ></i>
													)}
												</th>
												<th style={{ width: "150px" }}>مبلغ (تومان)</th>
											</tr>
										</thead>
										{!this.state.isRefreshing ? (
											<Fragment>
												{this.state.transactions.map((row, index) => (
													<TabAllTableRows key={row.id} index={index} data={row} showDetails={this.state.showDetails} />
												))}
											</Fragment>
										) : (
											<tbody>
												<tr>
													<td colSpan={8} style={{ padding: "20px" }}>
														<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
													</td>
												</tr>
											</tbody>
										)}
									</table>
									{/* <tfoot>
												<tr>
													<td colSpan={12}>
														<div className="table-pagination">
															{this.state.paging.pages.map((page, index) => (
																<Button
																	key={index}
																	className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })}
																	onClick={(e) => {
																		if (page.ellipse) {
																			return;
																		}
																		var tmpObj = { ...this.state.APISearchData };
																		tmpObj.currentPage = page.page;

																		this.setState({ APISearchData: tmpObj, isRefreshing: true }, () => {
																			this.loadData();
																		});
																	}}
																>
																	{page.page}
																</Button>
															))}

															<div className={"text-muted"} style={{ display: "block", clear: "both", marginTop: "16px", fontSize: "14px" }}>
																نمایش {this.state.paging.from + 1} - {Math.min(this.state.paging.to, this.state.paging.total)} از {this.state.paging.total} کوپن
															</div>
														</div>
													</td>
												</tr>
											</tfoot> */}
									{this.state.summary != false && (
										<Fragment>
											<div className="summary-grid">
												<div className="grid-item">
													<div className="grid-header">بالانس</div>
													<div className="grid-content">
														<NumberFormat
															style={{ textAlign: "center" }}
															value={this.state.summary.INFLOW - this.state.summary.OUTFLOW}
															prefix="تومان "
															suffix={this.state.summary.INFLOW - this.state.summary.OUTFLOW >= 0 ? "+" : "-"}
															displayType={"text"}
															thousandSeparator={true}
															renderText={(value, prop) => <div>{value}</div>}
														/>
													</div>
												</div>
												<div className="grid-item">
													<div className="grid-header">مجموع برداشت</div>
													<div className="grid-content">
														<NumberFormat
															style={{ textAlign: "center" }}
															value={this.state.summary.OUTFLOW}
															prefix="تومان "
															suffix={this.state.summary.OUTFLOW > 0 ? "-" : ""}
															displayType={"text"}
															thousandSeparator={true}
															renderText={(value, prop) => <div>{value}</div>}
														/>
													</div>
												</div>
												<div className="grid-item">
													<div className="grid-header">مجموع واریز</div>
													<div className="grid-content">
														<NumberFormat
															style={{ textAlign: "center" }}
															value={this.state.summary.INFLOW}
															prefix="تومان "
															suffix={this.state.summary.INFLOW > 0 ? "+" : ""}
															displayType={"text"}
															thousandSeparator={true}
															renderText={(value, prop) => <div>{value}</div>}
														/>
													</div>
												</div>
												{Object.keys(this.state.summary.INFLOW_SOURCES).map((source) => (
													<div className="grid-item" key={source}>
														<div className="grid-header">{source}</div>
														<div className="grid-content">
															<NumberFormat
																style={{ textAlign: "center" }}
																value={this.state.summary.INFLOW_SOURCES[source]}
																prefix="تومان "
																suffix={this.state.summary.INFLOW_SOURCES[source] > 0 ? "+" : ""}
																displayType={"text"}
																thousandSeparator={true}
																renderText={(value, prop) => <div>{value}</div>}
															/>
														</div>
													</div>
												))}
											</div>
										</Fragment>
									)}
								</div>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TabAllTableRows extends Component {
	render() {
		const {
			data: { id, type, createdAt, date, inflow_source, amount, description, operatorName, purchase },
			showDetails,
			index,
		} = this.props;

		const created = moment(createdAt).locale("fa").format("DD / MMMM / YYYY - HH:mm");
		const dateFa = moment(date).locale("fa").format("DD / MMMM / YYYY");
		const typeMappings = {
			INFLOW: "واریز",
			OUTFLOW: "برداشت",
		};
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					{showDetails && <td className={"text-muted"}>{operatorName}</td>}
					{showDetails && <td className={"text-muted"}>{created}</td>}
					<td className={"text-muted print-show-cell"} style={{ display: "none" }}>
						{index + 1}
					</td>
					<td className={"text-muted"}>
						{showDetails ? (
							<a href={`https://hub.akschap.com/node/${id}`} target="_blank">
								#{id}
							</a>
						) : (
							`#${id}`
						)}
					</td>
					<td className={"text-muted"}>{typeMappings[type]}</td>
					<td className={"text-muted"}>{inflow_source}</td>
					<td style={{ textAlign: "right" }} className="transaction-description">
						<div dangerouslySetInnerHTML={{ __html: description }} />
						{showDetails && purchase && <small className="text-muted">
							{purchase.productName} · تعداد: {Number(purchase.quantity).toLocaleString('fa-IR')} · قیمت واحد: {Number(purchase.total / purchase.quantity).toLocaleString('fa-IR', { maximumFractionDigits: 2 })} تومان
							{purchase.note && <div>{purchase.note}</div>}
						</small>}
					</td>
					<td>{dateFa}</td>
					<td style={{ color: type == "INFLOW" ? "green" : "red" }}>
						<NumberFormat style={{ textAlign: "center" }} value={amount} suffix={type == "INFLOW" ? "+" : "-"} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>
				</tr>
			</tbody>
		);
	}
}

// const mapStateToProps = ({ menu, settings }) => {
// 	return { logoutUser };
// };
// const AccountingJournalWithProtection = withPasswordProtection('accounting/transactions/password', 10)(AccountingJournal);

// export default injectIntl(
//   connect(mapStateToProps, { logoutUser })(AccountingJournalWithProtection)
// );

const mapStateToProps = ({ menu, settings }) => {
	return {};
};

const mapDispatchToProps = { logoutUser };

const AccountingJournalWithProtection = withPasswordProtection("accounting/transactions/password", 5)(AccountingJournal);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AccountingJournalWithProtection));

// export default injectIntl(connect(mapStateToProps, { logoutUser })(AccountingJournal));
